
import AppFullScreenContainer from "@/components/common/MobileFullScreenContainer.vue";
import AppToolbar from "@/components/common/ToolbarBase.vue";
import { LanguagesConfig } from "@/models/dossier-configs/languages";
import { DossierConfigService } from "@/services/dossier-config-service";
import Vue from "vue";
import { IBreadCrumb } from "winfakt-vue-components";
import AppAddLanguageModal from "./LanguagesAddModal.vue";
import {getTranslatedIsoLangName,  getTranslatedIsoLangNames, LanguageNamesDict } from "../../../utils/languages";
import { AuthService, UserConfigService, ViewService } from "@/services";
import { loadLanguageAsync } from "@/setup/i18n-setup";

export default Vue.extend({
	data() {
		return {
			languages: null as LanguagesConfig | null,
			newLangInput: "",
			addLangModal: false,
			path: [{
				to: "/settings", value: this.$ct("general")
			},     {value: this.$ct("languages")}] as IBreadCrumb[],
			translatedNames: {} as LanguageNamesDict
		};
	},
	watch: {
		addLangModal() {
			this.newLangInput = "";
		},
	},
	methods: {
		async removeLangClicked(i: number) {
			if (!this.languages) return;
			let confirm = this.$confirmBuilder(this.$ct("delete-confirm-language", {name: this.getLanguageName(this.languages.LanguageNames[i])}));
			confirm.setTitle(this.$ct("common.warning"));
			confirm.setClass("warning");
			let result = await confirm.show();
			if (result) {
				this.languages.LanguageNames.splice(i, 1);
			}
		},
		async save() {
			if (!this.languages) return;
			await DossierConfigService.saveLanguagesConfig(this.languages);
			this.$wf.notify(this.$ct("save-success"), "success", 3000, "check");
		},
		getLanguageName(lang:string):string{
			return getTranslatedIsoLangName(lang, this.translatedNames);
		},
		async setInterfaceLanguage(lang:string){
			let oldLanguage = this.$i18n.locale;
			await loadLanguageAsync(lang);
			let settings = UserConfigService.getGeneralSettings();
			settings.SelectedLang = lang;
			await UserConfigService.setGeneralSettings(settings);
			await AuthService.setLang(lang);
			await ViewService.translateViews(oldLanguage, lang);
		}
	},
	async mounted() {
		this.languages = DossierConfigService.getLanguages();
		this.translatedNames = await getTranslatedIsoLangNames();
	},
	components: {
		AppAddLanguageModal,
		AppFullScreenContainer,
		AppToolbar
	},
	i18nEx: {
		componentPrefix: "components.settings-default"
	}
});
